import React from 'react';

import { Builder } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { useAdminTools } from '~/techstyle-shared/react-admin';

export const ErrorWrapper = styled.span.attrs({
  'data-collection-disabled': true,
})`
  ${({ theme }) => theme.errorBackground}
  border: 1px solid ${({ theme }) => theme.colors.error};
  display: block;
  padding: 0.5em 1em;
  border-radius: 4px;
  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      display: none;
    `}
`;

export function BuilderDisabledCollection({ children, reason, ...props }) {
  const { enabled: isAdmin } = useAdminTools();
  return (
    <ErrorWrapper $isVisible={isAdmin || Builder.isEditing} {...props}>
      <h3>This content block has been disabled</h3>
      {reason && (
        <p>
          <strong>Reason: </strong>
          {reason}
        </p>
      )}
      {children}
    </ErrorWrapper>
  );
}

BuilderDisabledCollection.propTypes = {
  children: PropTypes.node,
  reason: PropTypes.string,
};

export default BuilderDisabledCollection;
